<template>
  <div>
    <Row v-if="custAgreementDetail">
      <Collapse
        v-model="index" accordion
      >
        <Panel
          v-for="(item, i) in data" :key="item.id"
          :name="i+''"
        >
          {{ item.startDate }} ~ {{ item.endDate }} {{ "- " + item.name }}
          <div slot="content">
            <Row class="detail-header">
              <span>供应商协议信息</span>
            </Row>
            <Row class="detail-content">
              <Row><Col span="5" class="left-label">协议名称：</Col><Col span="16" class="right-content">{{ item.name || "" }}</Col></Row>
              <Row><Col span="5" class="left-label">客户名称：</Col><Col span="16" class="right-content">{{ item.custName || "" }}</Col></Row>
              <Row><Col span="5" class="left-label">描述：</Col><Col span="16" class="right-content">{{ item.remark || "" }}</Col></Row>
              <Row><Col span="5" class="left-label">有效期：</Col><Col span="16" class="right-content">{{ `${item.startDate || ""}-${item.endDate || ""}` }}</Col></Row>
              <Row><Col span="5" class="left-label">协议状态：</Col><Col span="16" class="right-content">{{ item.statusName || "" }}</Col></Row>
            </Row>
            <Row class="detail-header">
              <span>结算规则</span>
            </Row>
            <Row class="detail-content">
              <Row class="detail-form-block">
                <Row class="detail-form-item">
                  <Row class="block-header">案件阶段费用</Row>
                  <Row class="block-content">
                    <Row><Col span="5" class="left-label">前期调查：</Col><Col span="16" class="right-content">{{ common.formateNumber(item.preInvestigationFee) }}</Col></Row>
                    <Row><Col span="5" class="left-label">立案阶段：</Col><Col span="16" class="right-content">{{ common.formateNumber(item.filingFee) }}</Col></Row>
                    <Row><Col span="5" class="left-label">行动阶段：</Col><Col span="16" class="right-content">{{ common.formateNumber(item.actionFee) }}</Col></Row>
                    <Row v-if="caseDetail.type == 'CC'"><Col span="5" class="left-label">公诉阶段：</Col><Col span="16" class="right-content">{{ common.formateNumber(item.publicProsecutionFee) }}</Col></Row>
                    <Row v-if="caseDetail.type == 'CC'"><Col span="5" class="left-label">判决阶段：</Col><Col span="16" class="right-content">{{ common.formateNumber(item.judgmentFee) }}</Col></Row>
                    <Row v-if="caseDetail.type == 'AC'"><Col span="5" class="left-label">处罚阶段：</Col><Col span="16" class="right-content">{{ common.formateNumber(item.punishFee) }}</Col></Row>
                  </Row>
                </Row>
                <Row class="detail-form-item">
                  <Row class="block-header">赔偿款分成比例</Row>
                  <Row class="block-content block-info-content">
                    <Row class="block-content-title">
                      <Row>
                        <div class="title-begin">金额下限</div>
                        <div class="title-end">金额上限</div>
                        <div class="title-proportion">比例</div>
                      </Row>
                    </Row>
                    <Row
                      v-for="(m,n) in item.ratios" :key="n"
                      :label-width="0"
                    >
                      <Row class="fee-loop-list" style="margin-bottom:0px;padding:4px 10px">
                        <Row class="fee-loop-content">
                          <div class="fee-loop-begin">
                            {{ common.formateNumber(m.minAmount) }}
                          </div>
                          <div class="fee-loop-end">
                            {{ m.maxAmount?common.formateNumber(m.maxAmount):"无" }}
                          </div>
                          <div class="fee-loop-proportion">
                            {{ `${m.ratio}%` }}
                          </div>
                        </Row>
                      </Row>
                    </Row>
                  </Row>
                </Row>
              </Row>
            </Row>
          </div>
        </Panel>
      </Collapse>
    </Row>
    <Row v-if="!custAgreementDetail">
      <p style="width:100%;font-size:20px;line-height:100px;text-align:center">暂无数据</p>
    </Row>
  </div>
</template>
<script>
export default {
  components: {},
  props: ['custAgreementDetail', 'isProjectInfo', 'type', 'caseDetail'],
  data () {
    return {
      data: [],
      index: '0',
      criminaSupplierList: []
    }
  },
  watch: {},
  created() {
    // 只在项目详情中展示客户协议历史数据,第0处为当前协议，后面的是历史数据
    // this.custAgreementDetail可能是数组，也可能是对象，实际上 this.custAgreementDetail 的作用只是为了获取id请求 /settlement/agreement/ 接口
    this.caseType = this.caseDetail.type == 'AC' ? 'administrative' : 'criminal'
    if (this.custAgreementDetail) {
      const tempArr = Array.isArray(this.custAgreementDetail) ? (this.isProjectInfo ? this.custAgreementDetail : this.custAgreementDetail[0]) : [this.custAgreementDetail]
      tempArr.forEach(item => this.getAgreementDetail(item.id))
    }
  },
  beforeMount() {},
  updated() {},
  methods: {
    getAgreementDetail(id) {
      const url = '/settlement/agreement/' + this.caseType + '/' + this.type + '/' + id
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.data.push(res.data)
        }
      })
    }
  }
}
</script>
  <style lang="scss">
  @import "./agreementInfo.scss";
  </style>



// WEBPACK FOOTER //
// src/view/agreement/supplierAgreementInfo.vue